import MainPage from '../pages/MainPage';

export default function App() {
  return <MainPage />;
}
